import React from 'react';
import { Star } from 'lucide-react';

export default function StarRating({
  value = 0,
  onChange = null,
  size = 20,
  readonly = false,
  showValue = false,
  count = 0
}) {
  const [hovered, setHovered] = React.useState(0);

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type="button"
          disabled={readonly}
          onClick={() => onChange && onChange(star)}
          onMouseEnter={() => !readonly && setHovered(star)}
          onMouseLeave={() => !readonly && setHovered(0)}
          className={`transition-transform ${readonly ? 'cursor-default' : 'cursor-pointer hover:scale-110'}`}
          aria-label={`${star} étoile${star > 1 ? 's' : ''}`}
        >
          <Star
            size={size}
            fill={(hovered || value) >= star ? '#ffd93d' : 'transparent'}
            stroke={(hovered || value) >= star ? '#ffd93d' : '#a0a0ab'}
            strokeWidth={1.5}
          />
        </button>
      ))}
      {showValue && value > 0 && (
        <span className="ml-1 text-sm font-medium text-[#ffd93d]">{value.toFixed(1)}</span>
      )}
      {count > 0 && (
        <span className="text-xs text-[#a0a0ab] ml-1">· {count} avis</span>
      )}
    </div>
  );
}
